import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProjectPositions } from '../../../api/project-positions';

export const getProjectPositionsAsync = createAsyncThunk(
  'projectPositions/getProjectPositions',
  getProjectPositions
);

export interface ProjectPosition {
  id: number;
  name: string;
  order: number | null;
}

interface ProjectPositionState {
  data: ProjectPosition[];
}

const initialState: ProjectPositionState = {
  data: []
};

export default createSlice({
  name: 'projectPositions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProjectPositionsAsync.fulfilled, (state, action) => {
      state.data = action.payload.data;
    });
  }
});
